const infopages = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Pages",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4",
        children: [
          {
            title: "Pages",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: false,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Page",
                submit_url: "/api/categories/$currentCategoryId/pages",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Page Title",
                    placeholder: "Enter Page Title",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                    contentlist: [],
                  },
                },
                additionalProps: {
                  icon: "",
                  // "slug": "",
                  subtitle: "",
                  info_box: false,
                  info_title: "",
                  info_description: "",
                  contentlist: [],
                },
              },
            },
            children: [
              {
                type: "infoPagesTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Select a Page",
                  type: "list",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pt-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  variant: "simple",
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style: "",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "Page Title",
                      placeholder: "Enter News Title",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    url: {
                      type: "slug",
                      label: "Slug",
                      url: "/infopage/$slug",
                      placeholder: "Enter Path / Slug",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    subtitle: {
                      type: "text",
                      label: "Sub-title",
                      placeholder: "Enter Sub-title",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    icon: {
                      type: "iconSelect",
                      label: "Icon",
                      placeholder: "Select Icon",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["Privacy"],
                    },
                    info_box: {
                      type: "checkbox",
                      label: "Add Information Box",
                      placeholder: "Info Box",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_title: {
                      type: "text",
                      label: "Info Title",
                      placeholder: "Enter Info Title",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_description: {
                      type: "ckeditor",
                      label: "Info Description",
                      placeholder: "Enter Description",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: false,
                      info: true,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    // description: {
                    //   type: "ckeditor",
                    //   label: "Description",
                    //   placeholder: "Enter Description",
                    //   required: false,
                    //   info: true,
                    //   character_count: 2000,
                    //   disabled: false,
                    //   class: "",
                    //   size: "12",
                    //   style: "",
                    // },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    contentlist: {
                      type: "contentlist",
                      label: "Content Section",
                      placeholder: "Select",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { infopages };
